export var INTERVIEW_CONNECTED_EVENT_STAGE;
(function (INTERVIEW_CONNECTED_EVENT_STAGE) {
    INTERVIEW_CONNECTED_EVENT_STAGE["INVITE_SENT"] = "InviteSent";
    INTERVIEW_CONNECTED_EVENT_STAGE["BOOKED"] = "Booked";
    INTERVIEW_CONNECTED_EVENT_STAGE["RESCHEDULED"] = "Rescheduled";
    INTERVIEW_CONNECTED_EVENT_STAGE["CANCELLED"] = "Cancelled";
    INTERVIEW_CONNECTED_EVENT_STAGE["COMPLETED"] = "Completed";
})(INTERVIEW_CONNECTED_EVENT_STAGE || (INTERVIEW_CONNECTED_EVENT_STAGE = {}));
export var INTERVIEW_CONNECTED_EVENT_INITIATED_BY;
(function (INTERVIEW_CONNECTED_EVENT_INITIATED_BY) {
    INTERVIEW_CONNECTED_EVENT_INITIATED_BY["TALENT"] = "Talent";
    INTERVIEW_CONNECTED_EVENT_INITIATED_BY["RECRUITER"] = "Recruiter";
})(INTERVIEW_CONNECTED_EVENT_INITIATED_BY || (INTERVIEW_CONNECTED_EVENT_INITIATED_BY = {}));
export var INTERVIEW_CONNECTED_EVENT_INTERVIEW_STATUS;
(function (INTERVIEW_CONNECTED_EVENT_INTERVIEW_STATUS) {
    INTERVIEW_CONNECTED_EVENT_INTERVIEW_STATUS["DONE"] = "Done";
    INTERVIEW_CONNECTED_EVENT_INTERVIEW_STATUS["CANCELLED"] = "Canceled";
    INTERVIEW_CONNECTED_EVENT_INTERVIEW_STATUS["CANCELLED_TALENT_NO_SHOW"] = "Cancelled - Talent No Show";
})(INTERVIEW_CONNECTED_EVENT_INTERVIEW_STATUS || (INTERVIEW_CONNECTED_EVENT_INTERVIEW_STATUS = {}));
